// ============================================================
// 服务条款页（公开访问，无需登录 — Waffo 审核要求）
// 结构对齐 Waffo Pancake T&C 模板 V1 订阅模式（16 节）
// ============================================================

import LegalPage, { type LegalSection } from '../components/LegalPage';

const sections: LegalSection[] = [
  {
    title: 'legal.terms.s1.title',
    paragraphs: ['legal.terms.s1.p1', 'legal.terms.s1.p2'],
  },
  {
    title: 'legal.terms.s2.title',
    paragraphs: ['legal.terms.s2.p1', 'legal.terms.s2.p2'],
  },
  {
    title: 'legal.terms.s3.title',
    paragraphs: ['legal.terms.s3.p1', 'legal.terms.s3.p2'],
  },
  {
    title: 'legal.terms.s4.title',
    paragraphs: ['legal.terms.s4.p1'],
  },
  {
    title: 'legal.terms.s5.title',
    paragraphs: [
      'legal.terms.s5.p1',
      'legal.terms.s5.p2',
      'legal.terms.s5.p3',
      'legal.terms.s5.p4',
    ],
  },
  {
    title: 'legal.terms.s6.title',
    paragraphs: ['legal.terms.s6.p1', 'legal.terms.s6.p2'],
  },
  {
    title: 'legal.terms.s7.title',
    paragraphs: [
      'legal.terms.s7.p1',
      'legal.terms.s7.p2',
      'legal.terms.s7.p3',
      'legal.terms.s7.p4',
    ],
  },
  {
    title: 'legal.terms.s8.title',
    paragraphs: ['legal.terms.s8.p1'],
  },
  {
    title: 'legal.terms.s9.title',
    paragraphs: ['legal.terms.s9.p1', 'legal.terms.s9.p2'],
  },
  {
    title: 'legal.terms.s10.title',
    paragraphs: ['legal.terms.s10.p1', 'legal.terms.s10.p2'],
  },
  {
    title: 'legal.terms.s11.title',
    paragraphs: ['legal.terms.s11.p1'],
  },
  {
    title: 'legal.terms.s12.title',
    paragraphs: ['legal.terms.s12.p1', 'legal.terms.s12.p2'],
  },
  {
    title: 'legal.terms.s13.title',
    paragraphs: ['legal.terms.s13.p1'],
  },
  {
    title: 'legal.terms.s14.title',
    paragraphs: ['legal.terms.s14.p1'],
  },
  {
    title: 'legal.terms.s15.title',
    paragraphs: ['legal.terms.s15.p1'],
  },
  {
    title: 'legal.terms.s16.title',
    paragraphs: ['legal.terms.s16.p1'],
  },
];

export default function Terms() {
  return (
    <LegalPage
      title="legal.terms.title"
      updated="legal.terms.updated"
      intro="legal.terms.intro"
      sections={sections}
    />
  );
}
